





































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';

import { WorkshopService, LookupsService } from '@/core/services';
import { InputFieldCpt, InputSelectCpt, SubmitButtonCpt, BaseFormComponent } from '@/core/components/form';
import { SimpleLookupModel, WorkshopClientLookups, CompanyModel, CompanyFormModel } from '@/core/models';

@Component({
  components: {
    InputFieldCpt,
    InputSelectCpt,
    SubmitButtonCpt,
  },
})
export default class EditClientFormCpt extends BaseFormComponent {
  @Prop({ default: false }) loading: boolean;
  @Prop() workshopId: number;
  @Prop() model: CompanyModel;

  @Watch('model', { deep: true })
  modelChanged(val: any, oldVal: any) {
    this.internalModel = this.getInternalModel();
  }

  internalModel = this.getInternalModel();
  isSubmitButtonDisabled = false;
  submitInProgress = false;
  loadingLookups = false;

  lookups = {
    counties: [] as SimpleLookupModel[],
    sectors: [] as SimpleLookupModel[],
  } as WorkshopClientLookups;

  async onSubmitForm() {
    await WorkshopService.postWorkshopClient(this.workshopId, this.internalModel);
    this.model.countyName = LookupsService.findLookupText(this.lookups.counties, this.model.countyId);
    this.model.companySectorName = LookupsService.findLookupText(this.lookups.sectors, this.model.companySectorId);
    this.$emit('onSave', this.model);
  }

  async created() {
    await this.initializeLookups();
    this.internalModel = this.getInternalModel();
  }

  private getInternalModel() {
    const internalModel = new CompanyFormModel();
    internalModel.attendee1Email = this.model.attendee1Email;
    internalModel.attendee1Name = this.model.attendee1Name;
    internalModel.attendee2Email = this.model.attendee2Email;
    internalModel.attendee2Name = this.model.attendee2Name;
    internalModel.id = this.model.id;
    internalModel.name = this.model.name;
    internalModel.countyId = this.model.countyId;
    internalModel.companySectorId = this.model.companySectorId;
    internalModel.workshopId = this.model.workshopId;
    internalModel.sectorDescription = this.model.sectorDescription;
    internalModel.noOfEmployees = this.model.noOfEmployees;
    return internalModel;
  }
  private async initializeLookups() {
    this.loadingLookups = true;
    try {
      const lookups = await WorkshopService.getWorkshopClientLookups();
      _.extend(this.lookups, lookups);
    } finally {
      this.loadingLookups = false;
    }
  }
}
